export const treatmentsCatalog = [
  {
    key: "invisalign",
    img: "https://customer-assets.emergentagent.com/job_imayo-studio/artifacts/33cpv1xj_invisalaign%20fallback%20Medium.jpeg",
    es: {
      name: "Ortodoncia Invisible — Invisalign",
      sub: "Invisalign Diamond Provider",
      lede:
        "Alineadores transparentes hechos a medida. Eficaces, removibles y prácticamente invisibles para que tu vida no se detenga.",
      points: [
        "Estudio 3D digital con escáner iTero",
        "ClinCheck virtual previo al inicio",
        "Citas espaciadas cada 6–8 semanas",
        "Compatible con cualquier estilo de vida",
        "Apto desde adolescentes",
      ],
      duration: "6 – 18 meses",
      sessions: "6 – 10 visitas",
    },
    ca: {
      name: "Ortodòncia Invisible — Invisalign",
      sub: "Invisalign Diamond Provider",
      lede:
        "Alineadors transparents fets a mida. Eficaços, removibles i pràcticament invisibles perquè la teva vida no s'aturi.",
      points: [
        "Estudi 3D digital amb escàner iTero",
        "ClinCheck virtual abans d'iniciar",
        "Visites espaiades cada 6–8 setmanes",
        "Compatible amb qualsevol estil de vida",
        "Apte des d'adolescents",
      ],
      duration: "6 – 18 mesos",
      sessions: "6 – 10 visites",
    },
  },
  {
    key: "implants",
    img: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1400&q=80",
    es: {
      name: "Implantología Dental",
      sub: "Vuelve a sonreír",
      lede:
        "Implantes de titanio de grado médico con planificación digital 3D y cirugía guiada por ordenador.",
      points: [
        "Implantes premium Straumann / Nobel Biocare",
        "Planificación 3D con TAC dental",
        "Cirugía guiada y mínimamente invasiva",
        "Carga inmediata cuando es posible",
        "Garantía de por vida sobre el implante",
      ],
      duration: "1 día – 6 meses",
      sessions: "2 – 5 visitas",
    },
    ca: {
      name: "Implantologia Dental",
      sub: "Torna a somriure",
      lede:
        "Implants de titani de grau mèdic amb planificació digital 3D i cirurgia guiada per ordinador.",
      points: [
        "Implants premium Straumann / Nobel Biocare",
        "Planificació 3D amb TAC dental",
        "Cirurgia guiada i mínimament invasiva",
        "Càrrega immediata quan és possible",
        "Garantia de per vida sobre l'implant",
      ],
      duration: "1 dia – 6 mesos",
      sessions: "2 – 5 visites",
    },
  },
  {
    key: "design",
    img: "https://images.unsplash.com/photo-1581585504970-f74e4c8f4f48?auto=format&fit=crop&w=1400&q=80",
    es: {
      name: "Diseño de Sonrisa",
      sub: "Estética dental",
      lede:
        "Una sonrisa pensada para tu rostro. Diseño digital previo, mock-up físico y resultado verificado antes de empezar.",
      points: [
        "Diseño 2D + 3D personalizado",
        "Mock-up físico de prueba",
        "Carillas de porcelana de baja invasión",
        "Composite estético libre de metales",
        "Blanqueamiento profesional incluido",
      ],
      duration: "2 – 6 semanas",
      sessions: "3 – 5 visitas",
    },
    ca: {
      name: "Disseny del Somriure",
      sub: "Estètica dental",
      lede:
        "Un somriure pensat per al teu rostre. Disseny digital previ, mock-up físic i resultat verificat abans de començar.",
      points: [
        "Disseny 2D + 3D personalitzat",
        "Mock-up físic de prova",
        "Carilles de porcellana de baixa invasió",
        "Composite estètic lliure de metalls",
        "Blanquejament professional inclòs",
      ],
      duration: "2 – 6 setmanes",
      sessions: "3 – 5 visites",
    },
  },
  {
    key: "kids",
    img: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?auto=format&fit=crop&w=1400&q=80",
    es: {
      name: "Mayo Kids — Odontopediatría",
      sub: "Odontología infantil",
      lede:
        "Un equipo y un espacio pensados para los más pequeños. Prevención, hábitos y primeras revisiones sin miedos.",
      points: [
        "Primera visita lúdica y gratuita",
        "Selladores y fluorizaciones preventivas",
        "Ortodoncia interceptiva temprana",
        "Educación en higiene para familias",
        "Sedación consciente con óxido nitroso",
      ],
      duration: "Revisiones semestrales",
      sessions: "Programa anual",
    },
    ca: {
      name: "Mayo Kids — Odontopediatria",
      sub: "Odontologia infantil",
      lede:
        "Un equip i un espai pensats per als més petits. Prevenció, hàbits i primeres revisions sense pors.",
      points: [
        "Primera visita lúdica i gratuïta",
        "Segelladors i fluoritzacions preventives",
        "Ortodòncia interceptiva primerenca",
        "Educació en higiene per a famílies",
        "Sedació conscient amb òxid nitrós",
      ],
      duration: "Revisions semestrals",
      sessions: "Programa anual",
    },
  },
  {
    key: "perio",
    img: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1400&q=80",
    es: {
      name: "Periodoncia & Encías",
      sub: "Salud que sostiene tu sonrisa",
      lede:
        "Tratamientos para conservar las bases de tu sonrisa: encías sanas, dientes firmes y aliento fresco.",
      points: [
        "Diagnóstico periodontal completo",
        "Raspado y alisado radicular",
        "Cirugía mucogingival estética",
        "Regeneración ósea guiada",
        "Mantenimientos personalizados",
      ],
      duration: "1 – 3 meses",
      sessions: "3 – 6 visitas",
    },
    ca: {
      name: "Periodòncia & Genives",
      sub: "Salut que sosté el teu somriure",
      lede:
        "Tractaments per conservar les bases del teu somriure: genives sanes, dents fermes i alè fresc.",
      points: [
        "Diagnòstic periodontal complet",
        "Raspat i allisat radicular",
        "Cirurgia mucogingival estètica",
        "Regeneració òssia guiada",
        "Manteniments personalitzats",
      ],
      duration: "1 – 3 mesos",
      sessions: "3 – 6 visites",
    },
  },
  {
    key: "aesthetic",
    img: "https://customer-assets-eiarnc6j.emergentagent.net/job_imayo-studio/artifacts/71k6l79c_smiling-woman-holding-teeth-shade-guide-2026-03-27-01-56-07-utc.webp",
    es: {
      name: "Estética Avanzada",
      sub: "Detalle y armonía",
      lede:
        "Composite, blanqueamiento y rejuvenecimiento perioral para una sonrisa armónica y natural.",
      points: [
        "Blanqueamiento dental LED",
        "Composite estético sin tallar",
        "Reconstrucción de aristas y bordes",
        "Microabrasión y micro-pulido",
        "Mantenimientos estéticos anuales",
      ],
      duration: "1 – 3 sesiones",
      sessions: "1 – 3 visitas",
    },
    ca: {
      name: "Estètica Avançada",
      sub: "Detall i harmonia",
      lede:
        "Composite, blanquejament i rejoveniment perioral per a un somriure harmònic i natural.",
      points: [
        "Blanquejament dental LED",
        "Composite estètic sense tallar",
        "Reconstrucció d'arestes i vores",
        "Microabrasió i micro-poliment",
        "Manteniments estètics anuals",
      ],
      duration: "1 – 3 sessions",
      sessions: "1 – 3 visites",
    },
  },
  {
    key: "endo",
    img: "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=1400&q=80",
    es: {
      name: "Endodoncia",
      sub: "Salva tu diente natural",
      lede:
        "Tratamientos de conductos con microscopio dental y técnicas mínimamente invasivas para conservar tu pieza original.",
      points: [
        "Microscopio dental Zeiss",
        "Localizador electrónico de ápices",
        "Sistemas mecanizados de última generación",
        "Tratamiento indoloro con anestesia local",
        "Resultado en una sola sesión cuando es posible",
      ],
      duration: "1 – 2 sesiones",
      sessions: "1 – 2 visitas",
    },
    ca: {
      name: "Endodòncia",
      sub: "Salva la teva dent natural",
      lede:
        "Tractaments de conductes amb microscopi dental i tècniques mínimament invasives per conservar la teva peça original.",
      points: [
        "Microscopi dental Zeiss",
        "Localitzador electrònic d'àpex",
        "Sistemes mecanitzats d'última generació",
        "Tractament indolor amb anestèsia local",
        "Resultat en una sola sessió quan és possible",
      ],
      duration: "1 – 2 sessions",
      sessions: "1 – 2 visites",
    },
  },
  {
    key: "prothesis",
    img: "https://images.unsplash.com/photo-1610228919128-25e22be7e1d0?auto=format&fit=crop&w=1400&q=80",
    es: {
      name: "Prótesis Dental",
      sub: "Función y belleza",
      lede:
        "Coronas, puentes y prótesis completas diseñadas digitalmente y fabricadas en zirconio o disilicato de litio.",
      points: [
        "Diseño CAD/CAM digital",
        "Coronas de zirconio monolítico",
        "Prótesis removibles flexibles",
        "Prótesis sobre implantes",
        "Pruebas estéticas antes del cementado",
      ],
      duration: "2 – 4 semanas",
      sessions: "2 – 4 visitas",
    },
    ca: {
      name: "Pròtesi Dental",
      sub: "Funció i bellesa",
      lede:
        "Corones, ponts i pròtesis completes dissenyades digitalment i fabricades en zirconi o disilicat de liti.",
      points: [
        "Disseny CAD/CAM digital",
        "Corones de zirconi monolític",
        "Pròtesis removibles flexibles",
        "Pròtesis sobre implants",
        "Proves estètiques abans del cimentat",
      ],
      duration: "2 – 4 setmanes",
      sessions: "2 – 4 visites",
    },
  },
];

export const promotions = [
  {
    key: "first_visit",
    badge: "GRATIS",
    es: {
      tag: "Siempre disponible",
      title: "Primera visita + diagnóstico",
      desc: "Exploración completa, radiografía panorámica si es necesaria, presupuesto cerrado y plan de tratamiento por escrito.",
      cta: "Reservar visita gratuita",
    },
    ca: {
      tag: "Sempre disponible",
      title: "Primera visita + diagnòstic",
      desc: "Exploració completa, radiografia panoràmica si cal, pressupost tancat i pla de tractament per escrit.",
      cta: "Reservar visita gratuïta",
    },
  },
  {
    key: "invisalign",
    badge: "200€",
    es: {
      tag: "Promoción Invisalign",
      title: "200€ de descuento + blanqueamiento gratis",
      desc: "Al iniciar tu tratamiento de ortodoncia invisible Invisalign este mes. Plazas limitadas a 10 pacientes mensuales.",
      cta: "Reservar diagnóstico",
    },
    ca: {
      tag: "Promoció Invisalign",
      title: "200€ de descompte + blanquejament gratis",
      desc: "En iniciar el teu tractament d'ortodòncia invisible Invisalign aquest mes. Places limitades a 10 pacients mensuals.",
      cta: "Reservar diagnòstic",
    },
  },
  {
    key: "implants",
    badge: "−100€",
    es: {
      tag: "Promoción Implantes",
      title: "100€ de descuento por implante",
      desc: "Aplicable a cada implante dental de tu plan de tratamiento. Financiación hasta 60 meses sin intereses.",
      cta: "Solicitar estudio",
    },
    ca: {
      tag: "Promoció Implants",
      title: "100€ de descompte per implant",
      desc: "Aplicable a cada implant dental del teu pla de tractament. Finançament fins a 60 mesos sense interessos.",
      cta: "Sol·licitar estudi",
    },
  },
  {
    key: "kids",
    badge: "🦷",
    es: {
      tag: "Mayo Kids",
      title: "Higiene solidaria",
      desc: "Trae un juguete nuevo y regalamos una higiene dental infantil. Una campaña que devuelve sonrisas allí donde más se necesitan.",
      cta: "Quiero participar",
    },
    ca: {
      tag: "Mayo Kids",
      title: "Higiene solidària",
      desc: "Porta una joguina nova i regalem una higiene dental infantil. Una campanya que retorna somriures on més es necessiten.",
      cta: "Vull participar",
    },
  },
  {
    key: "financing",
    badge: "0%",
    es: {
      tag: "Financiación",
      title: "Hasta 12 meses sin intereses",
      desc: "Y opciones de financiación flexibles hasta 60 meses con cuotas adaptadas a tu tratamiento.",
      cta: "Calcular cuota",
    },
    ca: {
      tag: "Finançament",
      title: "Fins a 12 mesos sense interessos",
      desc: "I opcions de finançament flexibles fins a 60 mesos amb quotes adaptades al teu tractament.",
      cta: "Calcular quota",
    },
  },
];

export const blogPosts = [
  {
    slug: "invisalign-todo-lo-que-debes-saber",
    img: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=1200&q=80",
    es: {
      category: "Ortodoncia",
      title: "Invisalign: todo lo que debes saber antes de empezar",
      excerpt: "Cómo funciona realmente la ortodoncia invisible, cuánto dura, cuánto cuesta y qué resultados puedes esperar.",
      date: "12 · Dic · 2026",
      read: "6 min de lectura",
    },
    ca: {
      category: "Ortodòncia",
      title: "Invisalign: tot el que has de saber abans de començar",
      excerpt: "Com funciona realment l'ortodòncia invisible, quant dura, quant costa i quins resultats pots esperar.",
      date: "12 · Des · 2026",
      read: "6 min de lectura",
    },
  },
  {
    slug: "implantes-sin-miedo",
    img: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1200&q=80",
    es: {
      category: "Implantología",
      title: "Implantes dentales sin miedo: cirugía guiada paso a paso",
      excerpt: "La planificación digital ha cambiado todo. Te explicamos el proceso completo de la cirugía guiada.",
      date: "28 · Nov · 2026",
      read: "8 min de lectura",
    },
    ca: {
      category: "Implantologia",
      title: "Implants dentals sense por: cirurgia guiada pas a pas",
      excerpt: "La planificació digital ho ha canviat tot. T'expliquem el procés complet de la cirurgia guiada.",
      date: "28 · Nov · 2026",
      read: "8 min de lectura",
    },
  },
  {
    slug: "diseno-sonrisa-mock-up",
    img: "https://images.unsplash.com/photo-1581585504970-f74e4c8f4f48?auto=format&fit=crop&w=1200&q=80",
    es: {
      category: "Estética",
      title: "El mock-up: cómo ver tu nueva sonrisa antes de empezar",
      excerpt: "Una prueba física, no invasiva, que te permite decidir con seguridad antes de cualquier tratamiento.",
      date: "10 · Nov · 2026",
      read: "4 min de lectura",
    },
    ca: {
      category: "Estètica",
      title: "El mock-up: com veure el teu nou somriure abans de començar",
      excerpt: "Una prova física, no invasiva, que et permet decidir amb seguretat abans de qualsevol tractament.",
      date: "10 · Nov · 2026",
      read: "4 min de lectura",
    },
  },
  {
    slug: "cuidado-encias-prevencion",
    img: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80",
    es: {
      category: "Salud bucodental",
      title: "El cuidado de las encías: prevenir es siempre más barato",
      excerpt: "La periodontitis afecta a 8 de cada 10 adultos. Cómo detectarla a tiempo y prevenirla en casa.",
      date: "22 · Oct · 2026",
      read: "5 min de lectura",
    },
    ca: {
      category: "Salut bucodental",
      title: "La cura de les genives: prevenir és sempre més barat",
      excerpt: "La periodontitis afecta 8 de cada 10 adults. Com detectar-la a temps i prevenir-la a casa.",
      date: "22 · Oct · 2026",
      read: "5 min de lectura",
    },
  },
  {
    slug: "mayo-kids-primera-visita",
    img: "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?auto=format&fit=crop&w=1200&q=80",
    es: {
      category: "Mayo Kids",
      title: "La primera visita al dentista: cómo lo hacemos en Mayo Kids",
      excerpt: "Un protocolo lúdico, sin miedos y diseñado por odontopediatras para que el primer recuerdo sea positivo.",
      date: "30 · Sep · 2026",
      read: "4 min de lectura",
    },
    ca: {
      category: "Mayo Kids",
      title: "La primera visita al dentista: com ho fem a Mayo Kids",
      excerpt: "Un protocol lúdic, sense pors i dissenyat per odontopediatres perquè el primer record sigui positiu.",
      date: "30 · Set · 2026",
      read: "4 min de lectura",
    },
  },
  {
    slug: "tecnologia-clinica-dental",
    img: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1200&q=80",
    es: {
      category: "Tecnología",
      title: "Tecnología que sí marca la diferencia en una clínica dental",
      excerpt: "Escáner intraoral, TAC 3D, microscopio dental: cuándo se usan y por qué cambian el resultado.",
      date: "15 · Sep · 2026",
      read: "7 min de lectura",
    },
    ca: {
      category: "Tecnologia",
      title: "Tecnologia que sí marca la diferència en una clínica dental",
      excerpt: "Escàner intraoral, TAC 3D, microscopi dental: quan s'utilitzen i per què canvien el resultat.",
      date: "15 · Set · 2026",
      read: "7 min de lectura",
    },
  },
];

export const jobPositions = {
  es: [
    { value: "odontologo_general", label: "Odontólogo/a general" },
    { value: "ortodoncista", label: "Ortodoncista" },
    { value: "implantologo", label: "Implantólogo/a" },
    { value: "higienista", label: "Higienista dental" },
    { value: "auxiliar", label: "Auxiliar dental" },
    { value: "recepcion", label: "Recepción / coordinación" },
    { value: "marketing", label: "Marketing y comunicación" },
    { value: "otro", label: "Otra posición / candidatura espontánea" },
  ],
  ca: [
    { value: "odontologo_general", label: "Odontòleg/a general" },
    { value: "ortodoncista", label: "Ortodoncista" },
    { value: "implantologo", label: "Implantòleg/a" },
    { value: "higienista", label: "Higienista dental" },
    { value: "auxiliar", label: "Auxiliar dental" },
    { value: "recepcion", label: "Recepció / coordinació" },
    { value: "marketing", label: "Màrqueting i comunicació" },
    { value: "otro", label: "Altra posició / candidatura espontània" },
  ],
};
